import { z } from 'zod';
export const paraBirimi = z.enum(['TRY', 'EUR', 'USD']);
export const noktaDurumu = z.enum(['KURULUM', 'AKTIF', 'BAKIM', 'PASIF']);
export const nokta = z.object({
    id: z.string(),
    kod: z.string(),
    ad: z.string(),
    grupAdi: z.string().nullable().optional(),
    adres: z.string().nullable().optional(),
    enlem: z.number().nullable().optional(),
    boylam: z.number().nullable().optional(),
    saatDilimi: z.string(),
    paraBirimi: paraBirimi,
    durum: noktaDurumu,
    raspiSeriNo: z.string().nullable().optional(),
    raspiIpAdresi: z.string().nullable().optional(),
    raspiSonPing: z.string().datetime().nullable().optional(),
    fotografCekimi: z.boolean(),
    rezervasyonAktif: z.boolean(),
    dolapSayisi: z.number().int().optional(),
    musaitDolapSayisi: z.number().int().optional(),
    olusturmaTarihi: z.string().datetime(),
});
export const noktaOlusturIstegi = z.object({
    kod: z
        .string()
        .min(2)
        .max(40)
        .regex(/^[A-Z0-9-]+$/, 'Sadece BUYUK harf, rakam ve tire'),
    ad: z.string().min(2).max(120),
    grupAdi: z.string().max(120).optional(),
    adres: z.string().max(300).optional(),
    enlem: z.number().min(-90).max(90).optional(),
    boylam: z.number().min(-180).max(180).optional(),
    saatDilimi: z.string().default('Europe/Istanbul'),
    paraBirimi: paraBirimi.default('TRY'),
    durum: noktaDurumu.default('KURULUM'),
    fotografCekimi: z.boolean().default(false),
    rezervasyonAktif: z.boolean().default(true),
});
export const noktaGuncelleIstegi = noktaOlusturIstegi.partial().omit({ kod: true });
export const noktaSorgusu = z.object({
    sayfa: z.coerce.number().int().min(1).default(1),
    boyut: z.coerce.number().int().min(1).max(100).default(20),
    arama: z.string().optional(),
    durum: noktaDurumu.optional(),
    paraBirimi: paraBirimi.optional(),
});
//# sourceMappingURL=nokta.js.map